namespace Nobox.Web.Modules.Administration.Tenant {
    export interface Berlangganan {
        inv_id?: number;
        clientid?: number;
        client_name?: string;
        client_vat?: number;
        client_country?: number;
        inv_number?: number;
        inv_date?: string;
        inv_duedate?: string;
        subs_expired?: string;
        inv_total?: number;
        inv_status?: number;
        inv_recurring?: number;
        inv_recurring_type?: string;
        product_id?: number;
        product_name?: string;
        product_image?: string;
    }
}
